import { useEffect, useState } from "react";
import { useListResourcesQuery } from "../generated";

interface ListResourcesQueryInput {
	arn: string;
	region: string;
	selectedView: string;
}

const useListResources = ({
	arn,
	region,
	selectedView,
}: ListResourcesQueryInput) => {
	const [resources, setResources] = useState<any[]>([]);
	const { data, loading, error, refetch } = useListResourcesQuery({
		variables: {
			arn, // value for 'arn'
			region, // value for 'region'
			ViewArn: selectedView, // value for 'ViewArn'
		},
		context: {
			apiName: "resource_explorer"
		},
	});

	useEffect(() => {
		if (data?.listResources?.items) {
			let resources_data: any = data?.listResources?.items;
			setResources(resources_data);
		}
	}, [data]);
	
	return { resources, loading, error, refetch }
};

export { useListResources }